// Polymarket's end_date is an estimate: an event keeps trading past it until
// its markets close. These decide where an event's data stops.

/** Upper bound for trade fetches: none while any market is open. */
export function tradesEndDate(
    endDate: string | null | undefined,
    hasOpenMarket: boolean
): string | undefined {
    return hasOpenMarket ? undefined : (endDate ?? undefined);
}

const DAY_MS = 24 * 60 * 60 * 1000;

export function startOfUtcDay(ms: number): number {
    return Math.floor(ms / DAY_MS) * DAY_MS;
}

/**
 * End of the asset overlay's fetch window. The overlay clears and refetches
 * whenever this changes, so an open event past end_date gets the end of the
 * current UTC day instead of now, and it moves once a day.
 */
export function assetOverlayEndDate(
    endDate: Date | null,
    hasOpenMarket: boolean,
    utcDayStartMs: number
): Date | null {
    const dayEndMs = utcDayStartMs + DAY_MS;
    return endDate && hasOpenMarket && endDate.getTime() < dayEndMs
        ? new Date(dayEndMs)
        : endDate;
}

/** End of the chart window: end_date, except that an open event past it runs to now. */
export function chartEndDate(
    endDate: Date | null,
    hasOpenMarket: boolean,
    nowMs: number
): Date | null {
    return endDate && hasOpenMarket && endDate.getTime() < nowMs
        ? new Date(nowMs)
        : endDate;
}
